import React, { useState } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    Label, 
    Button,
    InputGroup,
    InputGroupText,
    Badge,
    Alert,
    Spinner
} from 'reactstrap';

import { 
    FaPlusCircle, 
    FaEye, 
    FaFilePdf, 
    FaSearch,
    FaDownload,
    FaCalendarAlt,
    FaShoppingCart,
    FaShoppingBag,
    FaRupeeSign,
    FaFileInvoice,
    FaFilter
} from 'react-icons/fa';

import { FaArrowRotateRight } from "react-icons/fa6";

import ProducePurchase from '../../component/utility/setting/ProducePurchase';
import ProduceSale from '../../component/utility/setting/ProduceSale';

const ProduceSalePurchase = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [frDate, setFrDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('all');
    
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const get_sale_purchase_list = () => {
        setLoading(true);
        
        // Simulate API call
        setTimeout(() => {
            let list = [
                {
                    sl: 1,
                    trans_id: "SH1001",
                    trans_type: "Sale",
                    date: "04-02-2023",
                    amt: 1370.00,
                    invoice: <FaFilePdf className='me-2 cursor' color="#dc3545" size={18} title="Download Invoice"/>,
                    action: <FaEye className='me-2 cursor' color="#28a745" size={18} title="View Details" />,
                    rawData: {
                        customer: "ABC Traders",
                        items: "Rice, Wheat",
                        quantity: "150 kg"
                    }
                },
                {
                    sl: 2,
                    trans_id: "SH1002",
                    trans_type: "Sale",
                    date: "03-02-2023",
                    amt: 2370.00,
                    invoice: <FaFilePdf className='me-2 cursor' color="#dc3545" size={18} title="Download Invoice"/>,
                    action: <FaEye className='me-2 cursor' color="#28a745" size={18} title="View Details" />,
                    rawData: {
                        customer: "XYZ Corporation",
                        items: "Barley, Corn",
                        quantity: "200 kg"
                    }
                },
                {
                    sl: 3,
                    trans_id: "PH1002",
                    trans_type: "Purchase",
                    date: "03-02-2023",
                    amt: 870.00,
                    invoice: <FaFilePdf className='me-2 cursor' color="#dc3545" size={18} title="Download Invoice"/>,
                    action: <FaEye className='me-2 cursor' color="#28a745" size={18} title="View Details" />,
                    rawData: {
                        supplier: "Farm Fresh Supplies",
                        items: "Seeds, Fertilizer",
                        quantity: "50 kg"
                    }
                },
                {
                    sl: 4,
                    trans_id: "PH1006",
                    trans_type: "Purchase",
                    date: "03-02-2023",
                    amt: 1070.00,
                    invoice: <FaFilePdf className='me-2 cursor' color="#dc3545" size={18} title="Download Invoice"/>,
                    action: <FaEye className='me-2 cursor' color="#28a745" size={18} title="View Details" />,
                    rawData: {
                        supplier: "Agri Tools Ltd",
                        items: "Tools, Equipment",
                        quantity: "5 items"
                    }
                },
                {
                    sl: 5,
                    trans_id: "SH1008",
                    trans_type: "Sale",
                    date: "02-02-2023",
                    amt: 1850.00,
                    invoice: <FaFilePdf className='me-2 cursor' color="#dc3545" size={18} title="Download Invoice"/>,
                    action: <FaEye className='me-2 cursor' color="#28a745" size={18} title="View Details" />,
                    rawData: {
                        customer: "Local Market",
                        items: "Vegetables, Fruits",
                        quantity: "100 kg"
                    }
                },
                {
                    sl: 6,
                    trans_id: "PH1009",
                    trans_type: "Purchase",
                    date: "01-02-2023",
                    amt: 650.00,
                    invoice: <FaFilePdf className='me-2 cursor' color="#dc3545" size={18} title="Download Invoice"/>,
                    action: <FaEye className='me-2 cursor' color="#28a745" size={18} title="View Details" />,
                    rawData: {
                        supplier: "Organic Suppliers",
                        items: "Organic Seeds",
                        quantity: "25 kg"
                    }
                }
            ];
            
            setTableData(list);
            setFilteredData(list);
            setLoading(false);
        }, 1000);
    };

    // Enhanced search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        applyFilters(value, filterType);
    };

    const handleFilterType = (type) => {
        setFilterType(type);
        applyFilters(searchTerm, type);
    };

    const applyFilters = (search, type) => {
        let filtered = tableData;

        // Filter by transaction type
        if (type !== 'all') {
            filtered = filtered.filter(item => 
                item.trans_type.toLowerCase() === type.toLowerCase()
            );
        }

        // Filter by search term
        if (search) {
            filtered = filtered.filter(item =>
                item.trans_id.toLowerCase().includes(search.toLowerCase()) ||
                item.trans_type.toLowerCase().includes(search.toLowerCase()) ||
                item.date.includes(search) ||
                item.amt.toString().includes(search)
            );
        }

        setFilteredData(filtered);
    };

    // Calculate statistics
    const getStatistics = () => {
        const sales = tableData.filter(item => item.trans_type === 'Sale');
        const purchases = tableData.filter(item => item.trans_type === 'Purchase');
        
        return {
            totalTransactions: tableData.length,
            totalSales: sales.length,
            totalPurchases: purchases.length,
            totalSaleAmount: sales.reduce((sum, item) => sum + item.amt, 0),
            totalPurchaseAmount: purchases.reduce((sum, item) => sum + item.amt, 0),
            netAmount: sales.reduce((sum, item) => sum + item.amt, 0) - purchases.reduce((sum, item) => sum + item.amt, 0)
        };
    };

    const stats = getStatistics();

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaFileInvoice size={12} />
                    Transaction ID
                </div>
            ),
            selector: row => row.trans_id,
            sortable: true,
            cell: row => (
                <Badge 
                    color={row.trans_type === 'Sale' ? 'success' : 'primary'} 
                    className="font-monospace"
                    pill
                >
                    {row.trans_id}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaShoppingCart size={12} />
                    Type
                </div>
            ),
            selector: row => row.trans_type,
            sortable: true,
            cell: row => (
                <Badge 
                    color={row.trans_type === 'Sale' ? 'success' : 'info'} 
                    className="d-flex align-items-center gap-1"
                >
                    {row.trans_type === 'Sale' ? 
                        <FaShoppingBag size={12} /> : 
                        <FaShoppingCart size={12} />
                    }
                    {row.trans_type}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Date
                </div>
            ),
            selector: row => row.date,
            sortable: true,
            width: '140px'
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaRupeeSign size={12} />
                    Amount
                </div>
            ),
            selector: row => row.amt,
            sortable: true,
            cell: row => (
                <div className={`fw-bold ${row.trans_type === 'Sale' ? 'text-success' : 'text-primary'}`}>
                    &#8377; {row.amt.toLocaleString('en-IN', {minimumFractionDigits: 2})}
                </div>
            ),
            right: true
        },
        {
            name: 'Invoice',
            selector: row => row.invoice,
            sortable: false,
            center: true,
            width: '100px'
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '100px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Produce Sale Purchase' breadcrumbs='Home / Produce Sale Purchase'>
                {mode === 1 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            {/* Enhanced Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col lg={6}>
                                            <div className="d-flex flex-wrap gap-2">
                                                <Button 
                                                    color='primary' 
                                                    size="sm" 
                                                    onClick={get_sale_purchase_list}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaArrowRotateRight size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Refresh Data'}
                                                </Button>
                                                
                                                <Button 
                                                    color='success' 
                                                    size="sm" 
                                                    onClick={() => setMode(2)}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    New Sale
                                                </Button>
                                                
                                                <Button 
                                                    color='info' 
                                                    size="sm" 
                                                    onClick={() => setMode(3)}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    New Purchase
                                                </Button>

                                                <Button 
                                                    color='secondary' 
                                                    size="sm"
                                                    className="d-flex align-items-center gap-2"
                                                    disabled={tableData.length === 0}
                                                >
                                                    <FaDownload size={14} />
                                                    Export
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <Row>
                                                <Col md={8}>
                                                    <InputGroup size="sm">
                                                        <InputGroupText className="bg-light border-end-0">
                                                            <FaSearch className="text-muted" />
                                                        </InputGroupText>
                                                        <Input
                                                            type="search"
                                                            placeholder='Search transactions...'
                                                            value={searchTerm}
                                                            onChange={(e) => handleSearch(e.target.value)}
                                                            className="border-start-0"
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <Input
                                                        type="select"
                                                        size="sm"
                                                        value={filterType}
                                                        onChange={(e) => handleFilterType(e.target.value)}
                                                    >
                                                        <option value="all">All Types</option>
                                                        <option value="sale">Sales Only</option>
                                                        <option value="purchase">Purchases Only</option>
                                                    </Input>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Enhanced Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col lg={2} md={4} sm={6} className="mb-3">
                                        <Card className="border-0 bg-primary text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaFileInvoice size={24} className="mb-2" />
                                                <h5 className="mb-0">{stats.totalTransactions}</h5>
                                                <small>Total Transactions</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={2} md={4} sm={6} className="mb-3">
                                        <Card className="border-0 bg-success text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaShoppingBag size={24} className="mb-2" />
                                                <h5 className="mb-0">{stats.totalSales}</h5>
                                                <small>Total Sales</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={2} md={4} sm={6} className="mb-3">
                                        <Card className="border-0 bg-info text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaShoppingCart size={24} className="mb-2" />
                                                <h5 className="mb-0">{stats.totalPurchases}</h5>
                                                <small>Total Purchases</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={2} md={4} sm={6} className="mb-3">
                                        <Card className="border-0 bg-success text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaRupeeSign size={24} className="mb-2" />
                                                <h6 className="mb-0">&#8377; {stats.totalSaleAmount.toLocaleString('en-IN')}</h6>
                                                <small>Sales Amount</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={2} md={4} sm={6} className="mb-3">
                                        <Card className="border-0 bg-info text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaRupeeSign size={24} className="mb-2" />
                                                <h6 className="mb-0">&#8377; {stats.totalPurchaseAmount.toLocaleString('en-IN')}</h6>
                                                <small>Purchase Amount</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={2} md={4} sm={6} className="mb-3">
                                        <Card className={`border-0 text-white h-100 ${stats.netAmount >= 0 ? 'bg-success' : 'bg-warning'}`}>
                                            <CardBody className="text-center py-3">
                                                <FaRupeeSign size={24} className="mb-2" />
                                                <h6 className="mb-0">&#8377; {Math.abs(stats.netAmount).toLocaleString('en-IN')}</h6>
                                                <small>{stats.netAmount >= 0 ? 'Net Profit' : 'Net Loss'}</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Enhanced Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Transaction Records</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} transactions` :
                                                    'No transactions found'
                                                }
                                            </small>
                                        </div>
                                        <div className="d-flex gap-2">
                                            {searchTerm && (
                                                <Badge color="secondary">
                                                    Search: {filteredData.length}
                                                </Badge>
                                            )}
                                            {filterType !== 'all' && (
                                                <Badge color="info">
                                                    {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
                                                </Badge>
                                            )}
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaFileInvoice size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No transactions loaded yet</p>
                                            <small>Click "Refresh Data" to fetch the latest transaction data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading transactions...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No transactions match your search criteria</p>
                                                    <Button color="primary" size="sm" onClick={() => {
                                                        setSearchTerm('');
                                                        setFilterType('all');
                                                        setFilteredData(tableData);
                                                    }}>
                                                        Clear Filters
                                                    </Button>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>    
                        </Col>
                    </Row>
                )}

                {mode === 2 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-success text-white">
                                    <div className="d-flex align-items-center gap-2">
                                        <FaShoppingBag />
                                        <h5 className="mb-0">New Produce Sale</h5>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <ProduceSale back={() => setMode(1)} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>    
                )}
                
                {mode === 3 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-info text-white">
                                    <div className="d-flex align-items-center gap-2">
                                        <FaShoppingCart />
                                        <h5 className="mb-0">New Produce Purchase</h5>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <ProducePurchase back={() => setMode(1)} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>    
                )}
            </Page>
            <Footer />
        </>
    )
}

export default ProduceSalePurchase;